/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Not_VerifiedInputs */

const en_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email not yet verified. Please check your email and click the verification link.`)
};

const fr_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email pas encore vérifié. Veuillez vérifier votre email et cliquer sur le lien de vérification.`)
};

const de_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre E-Mail-Adresse ist noch nicht verifiziert. Bitte überprüfen Sie Ihre E-Mails und klicken Sie auf den Bestätigungslink.`)
};

const it_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email non ancora verificata. Controlla la tua email e clicca sul link di verifica.`)
};

const ru_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты еще не подтвержден. Пожалуйста, проверьте свою почту и перейдите по ссылке для подтверждения.`)
};

const es_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico aún no verificado. Por favor, revise su correo electrónico y haga clic en el enlace de verificación.`)
};

const zh_cn2_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱尚未验证。请检查您的邮箱并点击验证链接。`)
};

const ja_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスはまだ確認されていません。メールアドレスを確認し、確認リンクをクリックしてください。`)
};

const hi_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल अभी तक सत्यापित नहीं हुआ है। कृपया अपना ईमेल जांचें और सत्यापन लिंक पर क्लिक करें।`)
};

const pt_pt2_login_error_not_verified = /** @type {(inputs: Login_Error_Not_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail ainda não verificado. Por favor, verifique seu e-mail e clique no link de verificação.`)
};

/**
* | output |
* | --- |
* | "Email not yet verified. Please check your email and click the verification link." |
*
* @param {Login_Error_Not_VerifiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_not_verified = /** @type {((inputs?: Login_Error_Not_VerifiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Not_VerifiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_not_verified(inputs)
	if (locale === "de") return de_login_error_not_verified(inputs)
	if (locale === "it") return it_login_error_not_verified(inputs)
	if (locale === "ru") return ru_login_error_not_verified(inputs)
	if (locale === "es") return es_login_error_not_verified(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_not_verified(inputs)
	if (locale === "ja") return ja_login_error_not_verified(inputs)
	if (locale === "hi") return hi_login_error_not_verified(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_not_verified(inputs)
	return en_login_error_not_verified(inputs)
});